module.exports = __webpack_public_path__ + "static/media/bakri-instructions-for-use@3x.a0ac37c2.jpg";